import Image from "../../../atoms/Image"
import specXLogo from '../../../../assets/Images/specx_logo.jpg'
import { numberWithCommas } from "../../../../constants/utils";
import '../print.css'
import { OldFormatBarcodeProps } from "../interface";


export const OldFormatBarcode = ({item,togglePrice,index}:OldFormatBarcodeProps)=> {
    return (
        <div className={`d-flex flex-wrap align-items-center justify-content-around ${((index + 1) % 14 == 0) && 'page-break'
            } `} style={{
                width: '50mm',
                // minHeight: '13mm',
                minHeight: '15mm',
                marginTop: '1.75mm',
                marginBottom: '1.55mm',
                marginLeft: '1.5mm',
            }}>
            <div className="" style={{
                width: '19mm',

            }}>
                <h1 className="title text-uppercase m-0 p-0 fw-700">{item.brand_name}</h1>
                <p className={`price m-0 p-0 fw-800 ${togglePrice ? "show-barcode-price" : "hide-barcode-price"}`}>₹ {numberWithCommas(item.product_srp)} /-</p>
                <p className='price m-0 p-0 fw-800'>{item.bar_code}</p>
                <p className='product_id m-0 p-0 fw-600'>{item.product_id_display}</p>
            </div>

            <div className="" style={{
                width: '27mm',
                marginLeft: '15px',

            }}>
                <Image className='img-fluid' src={specXLogo} style={{ width: '150px' }} />
            </div>
        </div>
    )
}